(function() {
    'use strict';
    angular
    .module('wamasysApp')
    .factory('BatchJobs', BatchJobs);
	
    BatchJobs.$inject = ['$resource'];
	
	function BatchJobs($resource) {
	    return $resource('api/batch-jobs/monitoring', {}, {
	        'query': { method: 'GET', isArray: true },
	        'summary': {
	            method: 'GET',
	            url: 'api/batch-jobs/monitoring-summary'
	        }
	    });
	}

})();
